import { useEffect } from "react";
export function useEscapeKey(active, onEscape) {
    useEffect(() => {
        if (!active)
            return;
        const handler = (e) => {
            if (e.key === "Escape")
                onEscape();
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [active, onEscape]);
}
